/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input[_ngcontent-%COMP%], label[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]{width:9em!important}.fa-calendar-day[_ngcontent-%COMP%]{color:#cfcfcf;font-size:12px;display:flex;justify-content:center}mat-form-field[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
